import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
import { motion } from 'framer-motion';
import { startCheckout } from '../../lib/metaPixel';
interface SignCTAProps {
  sign: Sign;
}
export function SignCTA({
  sign
}: SignCTAProps) {
  return <section className="py-32 px-6" style={{
    background: `radial-gradient(circle at center, ${sign.colors.primary}25 0%, #050508 70%)`
  }} data-id="element-231">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-232">
        <AnimatedSection data-id="element-233">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" style={{
          textShadow: `0 0 40px ${sign.colors.primary}60`
        }} data-id="element-234">
            Tu reino ya está abierto.
          </h2>
          <p className="text-xl md:text-2xl mb-12 italic" style={{
          color: sign.colors.accent
        }} data-id="element-235">
            Solo falta que entres.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-236">
          <motion.button onClick={() => startCheckout(sign.name, sign.checkoutUrl, 9.99)} className="inline-block px-12 py-6 text-xl font-bold rounded-lg transition-all duration-300" style={{
          backgroundColor: sign.colors.primary,
          color: '#050508',
          boxShadow: `0 0 40px ${sign.colors.primary}60`
        }} whileHover={{
          scale: 1.05,
          boxShadow: `0 0 80px ${sign.colors.primary}90`
        }} whileTap={{
          scale: 0.95
        }} data-id="element-237">
            Desbloquear mi Arquetipo {sign.name}
          </motion.button>
        </AnimatedSection>
      </div>
    </section>;
}